<template>
  <div class="main-content">
    <div class="row">
      <div class="col-xs-12 m-b-sm">
        <div class="row table-filter">
          <div class="col-sm-2 col-xs-12">
            <h4 class="table-name">{{title}}</h4>
          </div>
        </div>
        <div class="b-b"></div>
      </div>
      <transition name="fade">
        <div class="col-xs-12" style="display:none;" :style="view_mounted">
          <form action="">
            <div class="form-group" v-if="action === 'add'">
              <div class="row">
                <div class="col-xs-2 text-right label p-t-b-sm ">
                  复制岗位:
                </div>
                <div class="col-xs-5 n-p-l">
                  <select v-model.trim="clone_post" class="input-md col-xs-12">
                    <option value="-1">请选择岗位</option>
                    <option :value="pt._id" v-for="pt in posts" :key="pt._id" v-if="pt.clone_able === 1">{{pt.name}}</option>
                  </select>
                </div>
                <div class="col-xs-4 p-t-b-sm n-p-l text-left">
                  <div class="left tooltips">
                    <i class="fa fa-question-circle-o"></i>
                    <div class="text">
                      可以复制已有岗位所有数据。<br />注意:自定数据会被覆盖。
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-xs-2 text-right label p-t-b-sm">
                  岗位名称:
                </div>
                <div class="col-xs-5  n-p-l">
                  <input type="text" class="input input-md" v-model.trim="post.name" placeholder="岗位名称：Java开发工程师">
                </div>
                <div class="col-xs-5 label p-t-b-sm n-p-l text-left">
                  *
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-xs-2 text-right label p-t-b-sm">
                  岗位别名:
                </div>
                <div class="col-xs-5  n-p-l">
                  <input type="text" class="input input-md" v-model.trim="post.alias" placeholder="岗位别名：Java开发工程师">
                </div>
                <div class="col-xs-5 label p-t-b-sm n-p-l text-left">
                  <div class="left tooltips">
                    <i class="fa fa-question-circle-o"></i>
                    <div class="text">
                      岗位别名在发送邀请时显示，通过“-”分割，选择第一段。<br />例如：<br />岗位名称：<br />“Java开发工程师-研发一部”，<br />别名：<br />“Java开发工程师”
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="form-group">
                            <div class="row">
                                <div class="col-xs-2 text-right label p-t-b-sm ">
                                    答题时间:
                                </div>
                                <div class="col-xs-5 n-p-l">
                                    <input type="number" step="0.01" class="input input-md" v-model.trim="post.duration" placeholder="答题时间：秒为单位，-1表示不限时">
                                </div>
                                <div class="col-xs-5 label p-t-b-sm n-p-l text-left">
                                    *（秒为单位，-1表示不限时）
                                </div>
                            </div>
                        </div> -->
            <div class="form-group">
              <div class="row">
                <div class="col-xs-2 text-right label p-t-b-sm">
                  关联能力群:
                </div>
                <div class="col-xs-8 n-p-l p-t-xs">
                  <button type="button" class="btn btn-success btn-sm left" @click="selectAbilities()">关联能力群</button>
                  <!-- <div class="left">
                                                                                                                                                                                                                                                                                                                                                                                                                                        <div class="input-tips m-l-sm">最多关联12个指标</div>
                                                                                                                                <!--/ select indicators start  /-->
                  <div class="row " v-if="ability_select_show">
                    <div class="col-xs-12 n-p-r m-t-sm">
                      <div class="col-xs-4 n-p-l m-b-sm" v-for="(ability,ind) in view_abilities" :key="ability._id">
                        <div class="btn col-xs-12" :class="{'btn-danger': ind % 3 === 2,'btn-success':ind % 3 === 0,'btn-warning':ind%3 === 1}">{{ability.name}}
                          <input type="checkbox" class="right" style="margin-top:9px;" :true-value="1" :false-value="0" v-model.number="ability.is_selected">
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 m-t-b-sm">
                      <div class="btn btn-sm btn-primary right" @click="confirmSelectAbilities()">确定</div>
                      <div class="btn btn-sm btn-default right m-r-sm" @click="cancelSelectAbilities()">取消</div>
                    </div>
                  </div>
                  <!--/ select abilities end  /-->
                  <div v-show="!ability_select_show">
                    <draggable v-model="post.abilities" :options="{'draggable':'.list-group-item'}" class="col-xs-12 m-t-sm list-group">
                      <div class="list-group-item row m-b-md" v-for="(ability,ind) in post.abilities" :key="ability.ability._id" :class="{'open': ability.is_opend === 1 }">
                        <div class="btn col-xs-12 n-b-r btn-md btn-success">
                          <div class="row">
                            <div class="col-xs-5">{{ability.ability.name}}</div>
                            <div class="col-xs-6">
                              <div class="row">
                                <div class="col-xs-6">
                                </div>
                                <div class="col-xs-6">
                                  <div class="row">
                                    <div class="left">权重：</div>
                                    <div class="col-xs-6 n-p-l">
                                      <input type="number" step="0.01" style="width:100%;height:18px;font-size:14px;" v-model.number="ability.weight" min="0" max="100" required>
                                    </div>
                                    <div class="left tooltips">
                                      <i class="fa fa-question-circle-o"></i>
                                      <div class="text">
                                        能力群权重是用来生成用户的综合能力得分。各能力群权重之和为100;权重为0时，该能力群不进行测评。
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-xs-1">
                              <span class="right" @click="delAbility(ind)">x</span>
                            </div>
                          </div>
                        </div>
                        <draggable v-model="ability.indicators" :options="{'draggable':'.list-group-sub-item'}" class="col-xs-12 m-t-sm list-group-sub">
                          <div class="list-group-sub-item" v-for="(indicator,ind) in ability.indicators" :key="indicator.indicator._id">
                            <div class="btn col-xs-12 n-f" :class="{'btn-success': ind % 3 === 2,'btn-warning':ind % 3 === 1,'btn-danger':ind%3 === 0}">
                              <div class="row">
                                <div class="col-xs-6">{{indicator.indicator.name}}</div>
                                <div class="col-xs-6">
                                  <div class="row">
                                    <div class="left">权重：</div>
                                    <div class="col-xs-6">
                                      <input type="number" step="0.01" style="width:100%;height:18px;" v-model.number="indicator.weight" min="0" max="100" @input="validateWeight(ability,indicator)" required>
                                    </div>
                                    <div class="left tooltips">
                                      <i class="fa fa-question-circle-o"></i>
                                      <div class="text">
                                        指标权重用来生成用户的对应能力群得分。同一能力群下指标权重之和为100;权重为0时，该指标不进行测评，不计入能力群得分计算模型中。
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </draggable>
                      </div>
                    </draggable>
                  </div>
                  <div class="clearfix"></div>
                  <div class=" b-b b-dashed"></div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-xs-2 text-right label p-t-b-sm">
                  岗位说明:
                </div>
                <div class="col-xs-10 n-p-l">
                  <textarea v-model.trim="post.desc" placeholder="备注" id="post-desc-editor"></textarea>
                </div>
              </div>
            </div>
            <div class="form-group text-center">
              <div class="btn btn-primary m-r-md" @click="upsert()">保存</div>
              <div class="btn btn-default" @click="clearEdit()">取消</div>
            </div>
          </form>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import "../../../../static/ueditor/ueditor.config";
import "../../../../static/ueditor/ueditor.all";
import "../../../../static/ueditor/lang/zh-cn/zh-cn";

import { mapGetters } from "vuex";
import { deepCopy } from "../../../plugins/utils";
import draggable from "vuedraggable";

// import WebUploader from 'webuploader'
import User from "../../../resource/user";
import Company from "../../../resource/company";
import Post from "../../../resource/post";

// import Indicator from '../../../resource/indicator'
// import Tag from '../../../resource/tag'
import Ability from "../../../resource/ability";

export default {
  components: {
    draggable
  },
  data: function() {
    return {
      action: "add",
      title: "新增岗位",
      posts: [],
      indicators: [],
      view_indicators: {},
      tags: [],
      view_tags: {},
      post: {
        name: "",
        alias: "",
        duration: -1,
        tags: [],
        indicators: [],
        examinations: [],
        category: 2,
        post_category: 2,
        plot: "",
        desc: "",
        abilities: []
      }, // 岗位
      clone_post: "-1",
      modal: {
        title: "新增岗位",
        edit: false,
        import: false
      },
      filter: {
        status: 0,
        search: "",
        current: 1,
        length: 20,
        start: 0,
        total: 0,
        isMy: 0,
        category: 2, // 岗位
        post_category: [1, 2]
      },
      import_posts: [],
      import_btn_active: true,
      editor: {
        ref: null,
        ready: false,
        interval: null
      },
      indicator_select_show: false,
      ability_select_show: false,
      tag_select_show: false,
      view_mounted: {
        display: "none"
      },
      abilities: {}, // 能力群数据
      view_abilities: [] // 能力群列表
    };
  },
  computed: {
    ...mapGetters({
      user: "loginUser"
    })
  },
  created: function() {
    let that = this;
    if (
      that.user.category === 2 ||
      that.user.role === 2 ||
      that.user.role === 3
    ) {
      let loading = 1;
      Ability.full({}).then(res => {
        let data = res.body;
        if (data.code == 0) {
          var abilities = data.result || [];
          abilities.forEach(function(ability) {
            ability.is_selected = -1;
            ability.weight = 0;
            that.abilities[ability._id] = ability;
            that.view_abilities.push(ability);
          });
          loading = -1;
        } else {
          alert(data.msg);
        }
      });
      if (that.$route.params._id) {
        // edit
        that.action = "edit";
        document.title = `修改岗位-企业控制台|${that.global.name}`;
        that.title = "修改岗位";
        Post.get({
          _id: that.$route.params._id
        }).then(
          res => {
            let data = res.body;
            if (data.code === 0) {
              //that.post = deepCopy(data.result)
              var runner = function() {
                if (loading === -1) {
                  var qn = deepCopy(data.result);
                  var abilities = [];
                  qn.abilities.forEach(function(ability) {
                    var tmp = that.abilities[ability.ability._id];
                    if (tmp) {
                      var ab = {
                        ability: {
                          _id: ability.ability._id,
                          name: ability.ability.name,
                          identifier: ability.ability.identifier
                        },
                        weight: ability.weight || 0,
                        threshold_value: ability.threshold_value,
                        indicators: [],
                        is_opened: 1
                      };
                      var tmpInds = {};
                      tmp.indicators.forEach(function(ind) {
                        tmpInds[ind.indicator._id] = {
                          indicator: {
                            _id: ind.indicator._id,
                            name: ind.indicator.name,
                            identifier: ind.indicator.identifier
                          },
                          weight: ind.weight,
                          is_selected: -1
                        };
                      });
                      ability.indicators.forEach(function(ind) {
                        var tmpInd = tmpInds[ind.indicator];
                        if (tmpInd) {
                          ab.indicators.push({
                            indicator: tmpInd.indicator,
                            weight: ind.weight
                          });
                          tmpInd.is_selected = 1;
                        }
                      });
                      for (var p in tmpInds) {
                        var ti = tmpInds[p];
                        if (ti.is_selected == -1) {
                          ab.indicators.push(ti);
                        }
                      }
                      abilities.push(ab);
                    }
                  });
                  qn.abilities = abilities;
                  that.post = qn;
                  if (data.result.alias) {
                    setTimeout(() => {
                      that.post.alias = data.result.alias;
                    }, 300);
                  }
                } else {
                  setTimeout(runner, 100);
                }
              };
              runner();
            } else {
              alert(data.msg);
            }
          },
          res => {}
        );
      } else {
        that.action = "add";
        document.title = `新增岗位-企业控制台|${that.global.name}`;
        that.title = "新增岗位";
        that.loadAllPosts();
      }
    } else {
      that.$router.replace("/");
    }
  },
  watch: {
    clone_post: function(now) {
      let that = this;
      if (now === "-1") {
        that.post = {
          name: "",
          alias: "",
          duration: -1,
          tags: [],
          indicators: [],
          abilities: [],
          examinations: [],
          category: 2,
          post_category: 2,
          plot: "",
          desc: ""
        };
      } else {
        Post.get({
          _id: now
        }).then(res => {
          let data = res.body;
          if (data.code === 0) {
            let Pabilities = data.result.abilities;
            delete data.result.abilities;
            for (let prop in that.post) {
              that.post[prop] = data.result[prop];
            }
            if (data.result.alias) {
              setTimeout(() => {
                that.post.alias = data.result.alias;
              }, 300);
            }
            that.post.category = 2;
            that.post.post_category = 2;
            let abilities = [];
            Pabilities.forEach(function(ability) {
              let tmp = that.abilities[ability.ability._id];
              if (tmp) {
                let ab = {
                  ability: {
                    _id: ability.ability._id,
                    name: ability.ability.name,
                    identifier: ability.ability.identifier
                  },
                  weight: ability.weight || 0,
                  threshold_value: ability.threshold_value,
                  indicators: [],
                  is_opened: 1
                };
                let tmpInds = {};
                tmp.indicators.forEach(function(ind) {
                  tmpInds[ind.indicator._id] = {
                    indicator: {
                      _id: ind.indicator._id,
                      name: ind.indicator.name,
                      identifier: ind.indicator.identifier
                    },
                    weight: ind.weight,
                    is_selected: -1
                  };
                });
                ability.indicators.forEach(function(ind) {
                  let tmpInd = tmpInds[ind.indicator];
                  if (tmpInd) {
                    ab.indicators.push({
                      indicator: tmpInd.indicator,
                      weight: ind.weight
                    });
                    tmpInd.is_selected = 1;
                  }
                });
                for (let p in tmpInds) {
                  let ti = tmpInds[p];
                  if (ti.is_selected == -1) {
                    ab.indicators.push(ti);
                  }
                }
                abilities.push(ab);
              }
            });
            that.post.abilities = abilities;
            that.cancelSelectAbilities();
          } else {
            alert(data.msg);
          }
        });
      }
    },
    "post.desc": function(now) {
      let that = this;
      if (that.editor.ready) {
        that.editor.ref.setContent(now);
      } else {
        if (that.editor.interval) {
          clearInterval(that.editor.interval);
          that.editor.interval = null;
        }
        that.editor.interval = setInterval(() => {
          if (that.editor.ready) {
            that.editor.ref.setContent(now);
            clearInterval(that.editor.interval);
            that.editor.interval = null;
          }
        }, 100);
      }
    },
    "post.name": function() {
      const that = this;
      that.post.alias = that.post.name.split("-")[0];
    }
  },
  methods: {
    loadAllPosts: function() {
      let that = this;
      Post.all({}).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            that.posts = data.result || [];
          } else {
            alert(data.msg);
          }
        },
        res => {}
      );
    },
    upsert: function() {
      let that = this;
      if (!that.post.name) {
        alert("请填写岗位名称");
        return;
      }
      let resolves = [
        res => {
          let data = res.body;
          if (data.code === 0) {
            if (that.post._id) {
              alert("岗位修改成功");
            } else {
              alert("岗位发布成功");
            }
            if (that.editor.ref) {
              try {
                that.editor.ref.destroy();
                that.editor.ref = null;
              } catch (e) {}
            }
            this.$router.replace("/company/posts");
          } else {
            alert(data.msg);
          }
        },
        res => {}
      ];
      let post = deepCopy(that.post);
      var qn = {
        name: post.name,
        alias: post.alias,
        duration: post.duration,
        show_type: post.show_type,
        ignore_guide: post.ignore_guide,
        plot: post.plot,
        desc: post.desc,
        category: 2,
        post_category: 2,
        abilities: []
      };
      let flag = 1;
      let flag2 = 1; // 能力群权重检查
      let flag2_score = 0;
      for (let ability of post.abilities) {
        let ab = {};
        ab.ability = ability.ability._id;
        ab.threshold_value = ability.threshold_value;
        ab.indicators = [];
        ab.weight = ability.weight;
        flag2_score += Number(ability.weight || "0");
        if (flag2_score > 100) {
          flag2 = -1;
          break;
        }
        let score = 0;
        for (let indicator of ability.indicators) {
          let wt = Number(indicator.weight || "0");
          score += wt;
          if (wt > 0) {
            ab.indicators.push({
              indicator: indicator.indicator._id,
              weight: wt
            });
          } else if (wt < 0) {
            flag = -1;
            break;
          }
        }
        if (flag == -1) {
          break;
        }
        if (score > 100) {
          flag = -1;
          break;
        }
        if (ab.indicators.length > 0) {
          qn.abilities.push(ab);
        }
      }
      if (flag == -1) {
        alert("请检查能力群内指标权重配置，单个能力群内指标权重之和不能大于100");
        return;
      }
      if (flag2 == -1) {
        alert("请检查能力群权重配置，能力群权重之和不能大于100");
        return;
      }
      qn.desc = that.editor.ref.getContent();
      if (that.post._id) {
        Post.update(
          {
            _id: post._id
          },
          qn
        ).then(...resolves);
      } else {
        Post.save({}, qn).then(...resolves);
      }
    },
    delAbility: function(index) {
      let that = this;
      if (that.post.abilities.length > index) {
        that.post.abilities.splice(index, 1);
      }
    },
    confirmSelectAbilities: function() {
      let that = this;
      let selectAbilities = that.view_abilities.filter(
        ability => ability.is_selected == 1
      );
      if (selectAbilities.length == 0) {
        that.post.abilities = [];
      } else {
        if (that.post.abilities.length == 0) {
          selectAbilities.forEach(function(ability) {
            that.post.abilities.push({
              ability: {
                _id: ability._id,
                name: ability.name,
                identifier: ability.identifier
              },
              weight: 100 / selectAbilities.length,
              indicators: ability.indicators,
              threshold_value: ability.threshold_value,
              is_opened: 1
            });
          });
        } else {
          let view_abilities = selectAbilities.reduce(function(res, val) {
            res[val._id] = {
              ability: {
                _id: val._id,
                name: val.name,
                identifier: val.identifier
              },
              weight: 100 / selectAbilities.length,
              indicators: val.indicators,
              threshold_value: val.threshold_value,
              is_opened: 1,
              is_selected: -1
            };
            return res;
          }, {});
          let abilities = [];
          that.post.abilities.forEach(function(ability) {
            let tmp = view_abilities[ability.ability._id];
            if (tmp) {
              abilities.push(ability);
              tmp.is_selected = 1;
            }
          });
          for (let p in view_abilities) {
            let va = view_abilities[p];
            if (va.is_selected == -1) {
              abilities.push(va);
            }
          }
          that.post.abilities = abilities;
        }
      }
      that.cancelSelectAbilities();
    },
    cancelSelectAbilities: function() {
      let that = this;
      that.view_abilities.forEach(function(ability) {
        ability.is_selected = -1;
      });
      that.ability_select_show = false;
    },
    selectAbilities: function() {
      let that = this;
      that.post.abilities.forEach(function(ability) {
        that.abilities[ability.ability._id].is_selected = 1;
      });
      that.ability_select_show = true;
    },
    delIndicator: function(index) {
      let that = this;
      if (that.post.indicators.length > index) {
        that.post.indicators.splice(index, 1);
      }
    },
    confirmSelectIndicator: function() {
      let that = this;
      let indicators = that.indicators.filter(ind => ind.is_selected == 1);
      if (indicators.length > 12) {
        alert("最多关联12个指标");
        return;
      } else {
        that.indicator_select_show = false;
        that.post.indicators = indicators;
        that.indicators = [];
        that.view_indicators = {};
      }
    },
    cancelSelectIndicator: function() {
      let that = this;
      that.indicator_select_show = false;
      that.indicators = [];
      that.view_indicators = {};
    },
    selectIndicators: function() {
      let that = this;
      that.indicator_select_show = true;
      Indicator.query({
        status: 1,
        all: 1
      }).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            that.indicators = data.result;
            that.indicators.forEach(ind => {
              ind.is_selected = 0;
              that.view_indicators[ind._id] = ind;
            });
            that.post.indicators.forEach(ind => {
              let tmp = that.view_indicators[ind._id];
              if (tmp) {
                tmp.is_selected = 1;
              }
            });
          } else {
            alert(data.msg);
          }
        },
        res => {}
      );
    },
    delTag: function(index) {
      let that = this;
      if (that.post.tags.length > index) {
        that.post.tags.splice(index, 1);
      }
    },
    closeTagSelect: function() {
      let that = this;
      let tags = that.tags.filter(ind => ind.is_selected == 1);
      if (tags.length > 6) {
        alert("最多关联6个标签");
        return;
      } else {
        that.indicator_select_show = false;
        that.post.tags = tags;
        that.tags = [];
        that.view_tags = {};
      }
    },
    openTagSelect: function() {
      let that = this;
      that.tag_select_show = true;
      Tag.query({
        status: 1,
        all: 1
      }).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            that.tags = data.result;
          } else {
            alert(data.msg);
          }
        },
        res => {}
      );
    },
    clearEdit: function() {
      let that = this;
      if (confirm(`您要放弃本次修改吗？`)) {
        this.$router.replace("/company/posts");
      }
    },
    validateWeight: function(ability, indicator) {
      let score = 0;
      let oth = 0;
      ability.indicators.forEach(val => {
        score += Number(val.weight);
        if (val.indicator._id != indicator.indicator._id) {
          oth += Number(val.weight);
        }
      });
      if (score > 100) {
        alert("能力群内指标权重之和不能大于100");
        indicator.weight = 100 - oth;
      }
    }
  },
  mounted: function() {
    let that = this;
    that.view_mounted = {
      display: "block"
    };
    that.editor.ref = UE.getEditor("post-desc-editor");
    that.editor.ref.ready(() => {
      that.editor.ready = true;
    });
  },
  beforeDestroy: function() {
    let that = this;
    if (that.editor.ref) {
      try {
        that.editor.ref.destroy();
        that.editor.ref = null;
      } catch (e) {}
    }
    if (that.editor.interval) {
      try {
        clearInterval(that.editor.interval);
        that.editor.interval = null;
      } catch (e) {}
    }
    that.editor.ready = false;
  }
};
</script>
<style lang="less" scoped>
.invitate-code {
  padding-left: 15px;
  padding-right: 15px;
  &.code_is_active {
    color: #42b983;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// edit.vue?84dbd06c